import { render } from "./DriverCard.vue?vue&type=template&id=0b4a7c2d&scoped=true"
import script from "./DriverCard.vue?vue&type=script&lang=js"
export * from "./DriverCard.vue?vue&type=script&lang=js"

import "./DriverCard.vue?vue&type=style&index=0&id=0b4a7c2d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b4a7c2d"]])

export default __exports__